import { Link } from "react-router-dom";

export function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="font-chalk text-2xl font-bold text-[#a855f7]">The Pooh Sheet</Link>
          <Link to="/" className="text-sm text-neutral-400 hover:text-white transition-colors duration-200">Back to site</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-10">
        <h1 className="font-display text-3xl font-black uppercase tracking-tight mb-2">{title}</h1>
        <p className="text-neutral-500 text-xs mb-8">Last updated: June 2026</p>
        <div className="space-y-6 text-sm text-neutral-300 leading-relaxed [&_h2]:font-display [&_h2]:text-lg [&_h2]:font-bold [&_h2]:uppercase [&_h2]:text-[#a855f7] [&_h2]:mt-2">
          {children}
        </div>
      </main>
    </div>
  );
}

export default function Privacy() {
  return (
    <LegalShell title="Privacy Policy">
      <section>
        <h2>What we collect</h2>
        <p>When you create an account we collect your name, email address and a securely hashed password. If you subscribe to a paid plan, payment is handled entirely by Stripe. We never see or store your card number. We also keep records of your picks activity on the site (watchlist, saved parlays, community posts) so the product works for you.</p>
      </section>
      <section>
        <h2>How we use it</h2>
        <p>Your information is used to operate your account, deliver the features you pay for, and keep the community safe. We do not sell your personal information to anyone. Period.</p>
      </section>
      <section>
        <h2>Cookies and sessions</h2>
        <p>We use secure, httpOnly cookies to keep you logged in. That's it. No cross site ad trackers, no creepy stuff.</p>
      </section>
      <section>
        <h2>Third party services</h2>
        <p>Payments run through Stripe (their privacy policy applies to payment data). Baseball statistics come from the official MLB Stats API and sportsbook lines from The Odds API. Neither receives your personal information from us.</p>
      </section>
      <section>
        <h2>Your rights</h2>
        <p>You can update your name in Settings at any time. To request deletion of your account and associated data, contact us and we will handle it promptly.</p>
      </section>
      <section>
        <h2>Data security</h2>
        <p>Passwords are hashed with bcrypt and never stored in plain text. All traffic to the site is encrypted with HTTPS.</p>
      </section>
      <section>
        <h2>Changes</h2>
        <p>If this policy changes we will update this page and the date above. Continued use of the site means you accept the current version.</p>
      </section>
    </LegalShell>
  );
}
